// Code for response transformations

export async function getJsonOrUndefined<T>(response: Response): Promise<T | undefined> {
  try {
    const data = (await response.json()) as T;
    return data;
  } catch (error) {
    return undefined;
  }
}
